import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerPricingDialogComponent } from './customer-pricing-dialog.component';
import { CustomerPricingDialogService } from './customer-pricing-dialog.service';
import { MatButtonModule } from '@angular/material/button';
import { MainPipe } from '../../pipes/pipes.module';

@NgModule({
  declarations: [CustomerPricingDialogComponent],
  imports: [CommonModule, MatButtonModule, MainPipe],
  entryComponents: [CustomerPricingDialogComponent],
  providers: [CustomerPricingDialogService],
  exports: [CustomerPricingDialogComponent],
})
export class CustomerPricingDialogModule {}
